<template lang="pug">
  y-dialog(v-if="showModal" v-model="showModal" scrollable max-width='600px' persistent)
    v-card
      v-card-title.px-4
        div.h6.basic800--text {{ $t('set_minimimum_order') }}
      v-divider.basic300
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      template(v-else)
        v-card-text.px-4.pt-4.pb-0
          v-form(ref="form")
            y-checkbox.my-auto.mx-0.pa-0(v-model="hasMinOrder" hide-details)
              template(v-slot:label)
                div.p1.my-auto {{ $t('store_has_minimum_order') }}
            .minorder.mt-4(v-if="hasMinOrder")
              p.mb-1.label.basic600--text.text-uppercase {{ $t('amount') }}*
              v-text-field.my-2(v-model="minOrderAmount" background-color="basic200" height="40" outlined dense placeholder="0" :prefix="$currency.symbol" type="number" :rules="rules.has_quantity")
      v-card-actions
        v-spacer
        v-btn(color='white', text @click='showModal = false')
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="clickSave()" :loading="isLoading")
          .button-AA-small.basic100--text {{ $t('save') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EditMinOrderAmount',
  props: ['open', 'company', 'settings'],
  data: () => ({
    isFetching: false,
    hasMinOrder: false,
    minOrderAmount: null,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    },
  }),
  mounted () {
    if (this.settings.min_amount) {
      this.minOrderAmount = this.settings.min_amount/this.$currency.multiplier
      this.hasMinOrder = true
    }
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let min_amount = null
      if (!this.hasMinOrder) {
        this.minOrderAmount = null
      }
      if (this.minOrderAmount) {
        min_amount = (parseFloat(this.minOrderAmount)).toFixed(this.$currency.exponent).replace('.', '')
      }
      this.$axios.patch(`/store/settings/${this.company.slug}/`, { min_amount: min_amount })
        .then(() => {
          this.showMessage(['success', this.$t('success_message.minimum_order_updated')])
          this.$emit('minamount', min_amount)
          this.showModal = false
        })
        .catch(() =>{
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "set_minimimum_order": "Set Minimum Order Amount",
    "store_has_minimum_order": "This store has minimum order amount"
  },
  "id": {
    "set_minimimum_order": "Set amaun minimum untuk Order",
    "store_has_minimum_order": "Store ini ada amaun order minimum"
  }
}
</i18n>
